var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SocialAuthBtn',{staticClass:"google-btn",attrs:{"id":"google-login-btn","img":_vm.GoogleLogo,"label":_vm.$t('shared.loginModule.socialAuthBtns.continueWithGoogle'),"color":"white","tiny":_vm.tiny},on:{"click":_vm.gLogin}})
}
var staticRenderFns = []

export { render, staticRenderFns }